import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { CandidateSummary } from '../../candidates/models/candidate-summary';
import { DataService } from '../../candidates/services/data.service';
import { JobPost } from '../../jobs/models/job-post';
import { UiStateStore } from '../../shared/store/ui-state-store.service';
import { ProgressStatuses } from '../models/progress-statuses';
import { WizardStore } from '../stores/wizard-store.service';

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss']
})
export class WizardComponent implements OnInit {

  _candidates: BehaviorSubject<CandidateSummary[]> = new BehaviorSubject<CandidateSummary[]>([]);
  public candidates: Observable<CandidateSummary[]> = this._candidates.asObservable();

  constructor(private candidatesDataService: DataService,
    private route: ActivatedRoute,
    private uiState: UiStateStore,
    public wizardStore: WizardStore) { }

  ngOnInit(): void {
    const jobId = this.route.snapshot.paramMap.get("jobId");
    if (!jobId) {
      return;
    }
    this.uiState.setSelectedJobId(jobId);
    this.wizardStore.setSelectedJobId(jobId);
    this.candidatesDataService.getMatchedCandidates(jobId, 1).subscribe(s => {
      this._candidates.next(s.result);
      this.wizardStore.getCandidateProfileInfos(jobId);
      this.candidatesDataService.getJobProgressStatus(jobId).subscribe(s => {
        switch (s.status) {
          case ProgressStatuses.Invited:
          case ProgressStatuses.Declined:
          case ProgressStatuses.Proposed:
            this.wizardStore.step = 3;
            break;
          case ProgressStatuses.Hired:
            this.wizardStore.inviteCandidate(s.candidateAccountId)
                            .then(x => this.wizardStore.step = 4);
            break;
          case ProgressStatuses.Finished:
          case ProgressStatuses.Closed:
            this.wizardStore.inviteCandidate(s.candidateAccountId)
                            .then(x => this.wizardStore.step = 5);
            break;
          default:
            this.wizardStore.step = 1;
            break;
        }
      });
    });
  }

  onJobSaved(jobPost: JobPost): void {
    this.wizardStore.setSelectedJobId(jobPost.id);
    this.candidatesDataService.getMatchedCandidates(jobPost.id, 1).subscribe(s => {
      this._candidates.next(s.result);
      this.wizardStore.step = 2;
    });
  }

  onCandidateSelected(candidateAccountId: string): void {
    this.wizardStore.inviteCandidate(candidateAccountId)
                    .then(x => this.wizardStore.step = 3);
  }

}
